import React, { createContext, ReactNode } from "react";
import { useAutoLogout } from "../hooks/useAutoLogout";

const AutoLogoutContext = createContext(null);

export const AutoLogoutProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    useAutoLogout(); // Initialize auto-logout
    return <AutoLogoutContext.Provider value={null}>{children}</AutoLogoutContext.Provider>;
};
